import { LinkTo } from '@ember/routing';

import Application from 'market-view-ui/components/application';
import Terms from 'market-view-ui/components/terms';

import './terms.scss';

<template>
  <Application>
    <main id="main-content" class="route-terms">
      <LinkTo @route="application" class="_back-link">
        &larr;Back to Market View
      </LinkTo>
      <h1>Market View Terms and Conditions</h1>
      <Terms />
    </main>
  </Application>
</template>
